import { ButtonCta, LinkNav, PageTitle } from '@sleepstation/components'
import { CopyParagraph } from '@sleepstation/components-copy'
import { VLayout } from '@sleepstation/components-layouts'
import { LAYOUT_ALIGN, LAYOUT_SPACING } from '@sleepstation/const'
import { mq, paddingV, themeFontBody } from '@sleepstation/style-api-helpers'
import { constrainWide } from '@sleepstation/style-mixins'
import { defaultTheme } from '@sleepstation/themes-public-site'
import PropTypes from 'prop-types'
import React from 'react'
import styled, { ThemeProvider } from 'styled-components'
import Border from '../../../../shared/Border'
import HeroBreakoutModule from '../../../../shared/breakoutModules/HeroBreakoutModule'
import nhsOptionsHeroStarscapes from './svg/starscapes'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled.div`
  position: relative;
  ${paddingV([
    [3, 3.5],
    [3, 5],
  ])}
  ${constrainWide()}
`

const Primary = styled(VLayout).attrs({
  spacing: LAYOUT_SPACING.X_LARGE,
  align: LAYOUT_ALIGN.START,
})`
  ${mq(`smallOnly`)} {
    max-width: 66%;
  }

  ${mq(`mediumUp`)} {
    max-width: 66%;

    > a {
      max-width: 50%;
    }
  }
`

const LinkNavUnderlined = styled(LinkNav)`
  text-decoration: underline;
  ${themeFontBody(`normal`)}
`
// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const PageHeader = ({
  title,
  backLink,
  forceAccepted,
  seenByEnrolment,
  forceAcceptedParagraph,
  action,
}) => {
  const showBannerCta = forceAccepted && seenByEnrolment

  return (
    <HeroBreakoutModule images={nhsOptionsHeroStarscapes} imageOffsetBottom={0}>
      <Layout data-cy="page-header">
        <Primary>
          <LinkNavUnderlined href={backLink.url} forceOpenInSameWindow>
            {backLink.label}
          </LinkNavUnderlined>
          <PageTitle data-cy="page-header-title">{title}</PageTitle>
          {showBannerCta && (
            <React.Fragment>
              <CopyParagraph>{forceAcceptedParagraph}</CopyParagraph>
              <ButtonCta
                linkLabel={`Continue`}
                linkUrl={action}
                forceOpenInSameWindow
              />
            </React.Fragment>
          )}
        </Primary>
      </Layout>
      <ThemeProvider theme={defaultTheme}>
        <Border edge="bottom" kind="inset" color="backgroundStart" />
      </ThemeProvider>
    </HeroBreakoutModule>
  )
}

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  backLink: PropTypes.object.isRequired,
  forceAccepted: PropTypes.bool.isRequired,
  seenByEnrolment: PropTypes.bool.isRequired,
  forceAcceptedParagraph: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
}

export default PageHeader
